export interface UnsavedChangesBackCoordinator {
  isDirty: () => boolean
  confirmDiscard: () => Promise<boolean>
  clearDirty: () => void
}

let activeCoordinator: UnsavedChangesBackCoordinator | null = null

/** Registro imperativo para back nativo (RW-M28 / RW-S02). */
export const registerUnsavedChangesBackCoordinator = (
  coordinator: UnsavedChangesBackCoordinator,
): (() => void) => {
  activeCoordinator = coordinator
  return () => {
    if (activeCoordinator === coordinator) {
      activeCoordinator = null
    }
  }
}

export const getUnsavedChangesBackCoordinator = (): UnsavedChangesBackCoordinator | null =>
  activeCoordinator
